import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { Incidencia } from '../../../interfaces/incidencia';
import { Entidad, TipoEntidad } from '../../../interfaces/entidad';
import { FormControl, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material';
import { TipoIncidenciaService } from '../../../providers/tipo-incidencia.service';
import { TipoIncidencia } from '../../../interfaces/tipo-incidencia';
import { Cotizacion } from '../../../interfaces/cotizacion';
import { CotizacionService } from '../../../providers/cotizacion.service';
import { ClienteService } from '../../../providers/cliente.service';
import { EntidadService } from '../../../providers/entidad.service';
import { ProspectoService } from '../../../providers/prospecto.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { Contacto } from '../../../interfaces/contacto';
import { Propuesta } from '../../../interfaces/propuesta';

@Component({
  selector: 'app-incidencia',
  templateUrl: './incidencia.component.html',
  styleUrls: ['./incidencia.component.scss']
})
export class IncidenciaComponent implements OnInit {
  @Input() entidad?: Entidad;
  @Input() contacto?: Contacto;
  @Input() propuesta?: Propuesta;
  @Input() IdCotizacion?: number | string;
  incidencia: Incidencia;
  entidades: Entidad[] = [];
  cargandoEntidades: boolean = false;
  cargandoPropuesta: boolean = false;
  incidenciaTipos: TipoIncidencia[] = [];
  cargandoTipos: boolean = false;
  cotizaciones: Cotizacion[] = <Cotizacion[]>[];
  cargandoCotizaciones: boolean = false;
  @Output() onIncidenciaInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario
  inputEntidadPlaceholder = '';
  propuestas:any=[];
  @ViewChild('incidenciaTipo') incidenciaTipo: MatSelect;

  entidadFormControl = new FormControl('', [
    Validators.required
  ]);
  tipoIncidenciaFormControl = new FormControl('', [
    Validators.required
  ]);
  observacionesFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private tipoIncidenciaService: TipoIncidenciaService,
    private prospectoService: ProspectoService,
    private entidadService: EntidadService,
    private clienteService: ClienteService,
    private cotizacionService: CotizacionService,
    private _propuestasSv: PropuestasService
  ) { }

  ngOnInit() {
  
    
    this.incidencia = new Incidencia();
    this.incidenciaTipos = [];
    this.cargandoTipos = true;
    this.tipoIncidenciaService.getTiposIncidencia().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposIncidencia) {
          respuesta.data.tiposIncidencia.forEach(tipoIncidencia => {
            this.incidenciaTipos.push(<TipoIncidencia>{
              id: tipoIncidencia.IdTipoIncidencia,
              descripcion: tipoIncidencia.TipoIncidenciaDesc
            });
          });
        }
      },
      () => {
        this.cargandoTipos = false;
      },
      () => {
        this.cargandoTipos = false;
      }
    );

    if (this.IdCotizacion != null) { // recibo una cotizacion
      this.incidencia.cotizacion = new Cotizacion();
      this.incidencia.cotizacion.IdCotizacion = this.IdCotizacion;
    }

    if(this.contacto && this.contacto.idContacto){
      this.incidencia.contacto=this.contacto.idContacto;
    }

    if (this.entidad && this.entidad.IdEntidad != null) { // si recibo una entidad la incidencia debe ser asignada a la entidad recibida
      this.incidencia.entidad.IdEntidad = this.entidad.IdEntidad;
      this.entidadFormControl.disable({ onlySelf: true }); // no se puede cambiar la entidad seleccionada      
      this.entidadFormControl.setValue(this.incidencia.entidad.IdEntidad);
      this.traerCotizaciones(+this.incidencia.entidad.IdEntidad);
      //console.log('estoy aca');
      
      this.traerPropuestas(this.incidencia.entidad.IdEntidad); /// traigo las propuestas de la entidad. 
      
      if (this.entidad.tipoEntidad) {
        if (this.entidad.tipoEntidad.IdTipo == 1) {
          this.inputEntidadPlaceholder = 'Prospecto';
          this.traerProspectos(this.entidad.IdEntidad);
        } else if (this.entidad.tipoEntidad.IdTipo == 2) {
          this.inputEntidadPlaceholder = 'Cliente';
          this.traerClientes(this.entidad.IdEntidad);
        }
      }
    } else {
      this.inputEntidadPlaceholder = 'Prospecto/Cliente';
      this.traerEntidades();
    }
  }

  traerEntidades(): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.entidadService.getEntidades(
      {
        page: 0,
        pageSize: 200
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {        
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion
              }
            });
          });
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La incidencia no podrá ser asignada'
          });
        }

        this.cargandoEntidades = false;
      },
      error => {
        this.cargandoEntidades = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  traerProspectos(IdProspecto: number | string): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.prospectoService.getProspectos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        IdEntidad: IdProspecto,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion
              }
            });
          });
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La incidencia no podrá ser asignada'
          });
        }

        this.cargandoEntidades = false;
      },
      error => {
        this.cargandoEntidades = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  traerClientes(IdCliente: number | string): void {
    this.entidades = [];
    this.cargandoEntidades = true;
    this.clienteService.getClientes(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        IdEntidad: IdCliente,
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion
              }
            });
          });
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'La incidencia no podrá ser asignada'
          });
        }

        this.cargandoEntidades = false;
      },
      error => {
        this.cargandoEntidades = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }


  traerPropuestas(entidad){
    this.cargandoPropuesta = true;
    this._propuestasSv.getPropuestas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
     {
      entidad_id:entidad
     }
    )
      .subscribe(
        respuesta => {
           console.log('Propuestas', respuesta);

          this.cargandoPropuesta = false;
          if(respuesta.data.length > 0){
            this.propuestas=respuesta.data;
          }else{
            this.propuestas=[];
          }
        },
        () => {
          this.cargandoPropuesta = false; // ocultar progress bar si se estaba mostrando
        },
        () => {
          this.cargandoPropuesta = false; // ocultar progress bar si se estaba mostrando
        }
      );
  
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onIncidenciaInput.emit();
  }

  onProspectoSelected(event: MatSelectChange): void {
    var IdEntidad = event.value
    this.traerCotizaciones(+IdEntidad);
    this.onClearCotizacion();
  }

  compararCotizacion(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdCotizacion == tipo2.IdCotizacion;
    }

    return false;
  }

  onClearCotizacion(event: any = null): void { // limpiar seleccionado
    if (event) {
      event.stopPropagation(); // porque si no se abre el select
    }

    this.incidencia.cotizacion = new Cotizacion(); // modificar modelo
  }

  traerCotizaciones(IdEntidad: number): void {
    this.cotizaciones = [];
    this.cargandoCotizaciones = true;
    this.cotizacionService.getCotizaciones(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        IdEntidad: IdEntidad
      }
    ).subscribe( // suscribimos una nueva busqueda
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.cotizaciones) {
          respuesta.data.cotizaciones.forEach((cotizacion) => {
            this.cotizaciones.push(<Cotizacion>{
              IdCotizacion: cotizacion.IdCotizacion,
              numero: cotizacion.numero
            });
          });
        }
      },
      () => {
        this.cargandoCotizaciones = false;
      },
      () => {
        this.cargandoCotizaciones = false;
      }
    );
  }

  getIncidencia(): Incidencia {
    if ((this.entidadFormControl.hasError('required') ||
      this.tipoIncidenciaFormControl.hasError('required') ||
      this.observacionesFormControl.hasError('required') ) && !this.contacto) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.entidadFormControl.markAsTouched();
      this.tipoIncidenciaFormControl.markAsTouched();
      this.observacionesFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.incidencia;
  }
}
